<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 5v7.82L12.87 27 5 19.15 19.16 5H27m0-2h-7.84a2 2 0 00-1.41.59L3.6 17.74a2 2 0 000 2.83l7.85 7.85a2 2 0 002.83 0l14.19-14.19a2 2 0 00.59-1.42L29 5a2 2 0 00-2-2z"/><path d="M21.31 9.31A1.34 1.34 0 1120 10.64a1.33 1.33 0 011.33-1.33m0-1a2.34 2.34 0 102.33 2.33 2.33 2.33 0 00-2.33-2.33z"/></svg>